import sendSyncToExagonOutbound from '@hooks/configuration/sendSyncToExagonOutbound';

const usePostSyncToExagonOutbound = (id) => sendSyncToExagonOutbound(id);

export default usePostSyncToExagonOutbound;
